import { ThemeProvider } from '@emotion/react';
import AppBar from '@mui/material/AppBar';
import { createTheme } from '@mui/material/styles';

import * as React from 'react';

//
const colortheme = createTheme({
  palette: {
    primary: {
      main: '#4f4b6b',
    },
  },
  typography: {
    fontSize: 10,
    fontFamily: ['lato'].join(','),
  },
});

// const AppIconSection = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   justifyContent: 'center',
//   position: 'absolute',
//   zIndex: 1,
//   top: 5,
//   margin: '0 auto',
//   width: '100%',
//   cursor: 'pointer',
// }));

// const App = styled(Box)(({ theme }) => ({
//   borderRadius: '50%',
//   width: '55px',
//   height: '55px',
//   backgroundColor: '#4f4b6b',
//   boxShadow: theme.shadows[4],
//   '& img': {
//     width: '100%',
//     height: '100%',
//   },
// }));

const GlobalFooter = () => {
  // const AppIcon = require('assets/appicon.png');

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <AppBar
          position="fixed"
          sx={{
            top: 'auto',
            bottom: 0,
            height: '75px',
            justifyContent: 'center',
            width: '100vw',
            left: 0,
            boxShadow: 'none',
            background: 'rgba(41, 39, 57,0.2)',
            transition: 'all',
          }}
        >
          {/* <HamburgerMenu>
            <AppIconSection>
              <App>
                <img src={AppIcon} alt="app main icon" />
              </App>
            </AppIconSection>
          </HamburgerMenu> */}
        </AppBar>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default GlobalFooter;
